import { Directive, forwardRef, Attribute } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
// This compares if two strings are equal i.e. in the case of passwords
// setting the attribute reverse to true enables you to compare if string1 has changed
@Directive({
  selector: '[appEqualvalidator][formControlName],[validateEqual][formControl],[validateEqual][ngModel]',
  providers: [
          { provide: NG_VALIDATORS, useExisting: forwardRef(() => EqualvalidatorDirective), multi: true }
  ]
})
export class EqualvalidatorDirective implements Validator{

  constructor(@Attribute('appEqualvalidator') public appEqualvalidator: string, @Attribute('reverse') public reverse: string) { }

  private get isReverse() {
    if (!this.reverse) return false;
    return this.reverse === 'true' ? true: false;
}
  validate(c: AbstractControl): { [key: string]: any } {
    // self value
    let v = c.value;

    // control vlaue
    let e = c.root.get(this.appEqualvalidator);

    // value not equal
    if (e && v !== e.value && !this.isReverse) {
        return {
          appEqualvalidator: false
        }
    }


    // value equal and reverse
    if (e && v === e.value && this.isReverse) {
        delete e.errors['appEqualvalidator'];
        if (!Object.keys(e.errors).length) e.setErrors(null);
    }

    // value not equal and reverse
    if (e && v !== e.value && this.isReverse) {
        e.setErrors({ appEqualvalidator: false });
    }

    return null;
  }

}
